export class ProfileElement {
  id: number;
  name: string;
  link: string;
  icon: string;
}
